import React, { useState, useEffect } from 'react';
import axios from 'axios';

const CarHireDestinations = () => {
    const [destinations, setDestinations] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchDestinations();
    }, []);

    const fetchDestinations = async () => {
        try {
            const response = await axios.get('/api/car-hire/rental-locations/?featured=true');
            const destinationsData = response.data.results || response.data || [];
            setDestinations(Array.isArray(destinationsData) ? destinationsData.slice(0, 8) : []); // Show only first 8 featured destinations
        } catch (error) {
            console.error('Error fetching destinations:', error);
            setDestinations([]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDestinationClick = (destination) => {
        // Navigate to search page with pre-selected location
        const searchUrl = `/car-hire/search?pickup_location_id=${destination.id}`;
        window.location.href = searchUrl;
    };

    if (isLoading) {
        return (
            <section className="destinations__area section-padding bg-light">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="section__title text-center mb-5">
                                <h2>Popular Rental Locations</h2>
                            </div>
                            <div className="text-center">
                                <i className="fas fa-spinner fa-spin fa-2x"></i>
                                <p>Loading destinations...</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="destinations__area section-padding bg-light">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="section__title text-center mb-5">
                            <h2>Popular Rental Locations</h2>
                            <p>Discover car rentals in top destinations worldwide</p>
                        </div>
                    </div>
                </div>
                
                <div className="row">
                    {destinations.map((destination) => (
                        <div key={destination.id} className="col-xl-3 col-lg-4 col-md-6 mb-4">
                            <div 
                                className="destinations__area-item cursor-pointer"
                                onClick={() => handleDestinationClick(destination)}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="destinations__area-item-image">
                                    <img 
                                        src={`assets/images/destinations/${destination.city.toLowerCase().replace(/\s+/g, '-')}.jpg`}
                                        alt={`${destination.name}, ${destination.city}`}
                                        onError={(e) => {
                                            if (!e.target.dataset.errorHandled) {
                                                e.target.dataset.errorHandled = 'true';
                                                e.target.src = 'assets/images/destinations/default-destination.jpg';
                                            } else {
                                                e.target.style.display = 'none';
                                            }
                                        }}
                                    />
                                    <div className="destinations__area-item-overlay">
                                        <div className="destinations__area-item-overlay-content">
                                            <i className="fas fa-car"></i>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="destinations__area-item-content">
                                    <div className="destinations__area-item-content-top">
                                        <h5>{destination.city}</h5>
                                        <p>{destination.country}</p>
                                    </div>
                                    
                                    <div className="destinations__area-item-content-middle">
                                        <div className="location-details">
                                            <div className="location-type">
                                                <i className="fas fa-map-marker-alt"></i>
                                                <span>{destination.location_type_display}</span>
                                            </div>
                                            
                                            {destination.airport_code && (
                                                <div className="airport-code">
                                                    <i className="fas fa-plane"></i>
                                                    <span>{destination.airport_code}</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    
                                    <div className="destinations__area-item-content-bottom">
                                        <div className="location-name">
                                            <small>{destination.name}</small>
                                        </div>
                                        
                                        <div className="search-btn">
                                            <button className="btn-outline-primary btn-sm">
                                                Search Cars <i className="fas fa-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                
                <div className="row mt-4">
                    <div className="col-xl-12 text-center">
                        <a href="/car-hire/rental-locations" className="btn-two">
                            View All Locations <i className="fas fa-chevron-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CarHireDestinations;
